export default class OrderPurchasePendingTimer {
  constructor({
    timeout,
    statusPath,
    immediate = false,
  }) {
    this._timeout = timeout;
    this._statusPath = statusPath;
    this._immediate = immediate;
    this._retries = 0;
    if (timeout == null || statusPath == null || statusPath === "") {
      throw new TypeError(`Some arguments are not provided. timeout: ${timeout}, statusPath: ${statusPath}`);
    }
    this._result = new Promise((resolve, reject) => {
      this._onPaymentSucceed = () => resolve();
      this._onPaymentRejected = () => reject();
    });
  }

  destroy() {
    const destroyed = this._redirectTimer != null;
    window.clearTimeout(this._redirectTimer);
    this._redirectTimer = null;
    return destroyed;
  }

  run() {
    this._initializeTimers();
    return this._result;
  }

  _initializeTimers() {
    if (this._immediate === true) {
      this._timerHandler();
      this._immediate = false;
      return this;
    }
    if (this._redirectTimer != null) {
      window.clearTimeout(this._redirectTimer);
    }
    this._redirectTimer = window.setTimeout(this._timerHandler.bind(this), this._timeout);

    return this;
  }

  _timerHandler() {
    const self = this;
    $.ajax({
      url: self._statusPath,
      cache: false,
      dataType: "json",
      success: self._onSuccess.bind(self),
      error: self._onError.bind(self),
    });
  }

  _onSuccess(res) {
    this._retries = 0;
    if (res.url && res.url !== "") {
      this._onPaymentSucceed();
      window.location.href = res.url;
    } else {
      this._timeout = res.timeout || 10000;
      this._initializeTimers();
    }
  }

  _onError(res) {
    this._retries++;
    if (res.url) {
      this._onPaymentRejected();
      window.location.href = res.url;
    }
    if (this._retries < 10) {
      this._timeout = 10000;
      this._initializeTimers();
    } else {
      this._onPaymentRejected();
      window.location.reload();
    }
  }
}
